"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./PerformanceChart.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const PerformanceChart = ({
  currRange,
  data,
  legend,
  onClick,
  ranges,
  subtitle,
  threshold,
  title,
  variant,
  graphHeight = 60
}) => (0, _pragma.createFelaElement)(_.Card, {
  as: _.View,
  css: css.root,
  flexDirection: "column"
}, (0, _pragma.createFelaElement)(_.View, {
  gap: "xxsmall",
  padding: "medium"
}, (0, _pragma.createFelaElement)(_.Text, null, title), (0, _pragma.createFelaElement)(_.Text, {
  color: "text.meta"
}, subtitle)), (0, _pragma.createFelaElement)(_.LineGraph, {
  data: data,
  fallback: (0, _pragma.createFelaElement)(_.View, {
    alignItems: "center",
    children: (0, _pragma.createFelaElement)(_.Loading, null),
    css: css.fallback,
    justifyContent: "center"
  }),
  height: graphHeight,
  responsive: true,
  threshold: threshold,
  variant: variant
}), (0, _pragma.createFelaElement)(_.View, {
  justifyContent: "space-between",
  padding: "medium"
}, (0, _pragma.createFelaElement)(_.View, {
  alignItems: "center",
  gap: "xsmall"
}, (0, _pragma.createFelaElement)(_.LineGraphIcon, {
  color: "data.positive",
  size: "large"
}), (0, _pragma.createFelaElement)(_.Text, null, legend)), (0, _pragma.createFelaElement)(_.TimeFrame, {
  currRange: currRange,
  onClick: onClick,
  ranges: ranges
})));

PerformanceChart.displayName = 'PerformanceChart';
var _default = PerformanceChart;
exports.default = _default;
//# sourceMappingURL=PerformanceChart.js.map